import type { IDropdownOption } from "@fluentui/react";
import { Dropdown } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { type NodeProps, type Node } from "@xyflow/react";
import type { CheckFlagData } from "../../../api";
import { CheckFlagCondition, ActionFlag } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

export type CheckFlagNode = Node<InterfaceToRecord<CheckFlagData & ExtraNodeData>>;

export default function CheckFlag(props: NodeProps<CheckFlagNode>): JSX.Element {
    const { t }: { t: TFunction } = useTranslation();
    const [actionFlag, setActionFlag] = useState(props.data.flag ?? ActionFlag.STATIC_FLAG_ZERO);
    const [condition, setCondition] = useState(
        props.data.condition ?? CheckFlagCondition.ALL_ANTENNAS_AIN_ZONE1,
    );

    const updateNode = useUpdateNodeData<CheckFlagNode>(props.id);

    // Effect to update props data when internal state changes
    useEffect(() => {
        updateNode({ flag: actionFlag, condition: condition });
    }, [actionFlag, condition, updateNode]);

    const dropdownOptionsActionflag: IDropdownOption[] = Object.values(ActionFlag).map(
        (key, index) => ({
            key,
            text: t(`component.actionConfigNodes.checkFlag.actionFlag.${index}`),
        }),
    );

    const dropdownOptionsCheckFlagCondition: IDropdownOption[] = Object.values(
        CheckFlagCondition,
    ).map((key, index) => ({
        key,
        text: t(`component.actionConfigNodes.checkFlag.condition.${index}`),
    }));

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <Dropdown
                options={dropdownOptionsActionflag}
                selectedKey={actionFlag}
                onChange={(_e, option) => setActionFlag(option?.key as ActionFlag)}
                styles={{ dropdown: { width: 400 } }}
            />

            <Dropdown
                label={t("component.actionConfigNodes.checkFlag.condition.label")}
                options={dropdownOptionsCheckFlagCondition}
                selectedKey={condition}
                onChange={(_e, option) => setCondition(option?.key as CheckFlagCondition)}
                styles={{ dropdown: { width: 400 } }}
            />
        </ActionConfigNode>
    );
}
